const BOOKMARKS_UPDATED = (state, bookmarks) => {
  state.bookmarks = bookmarks
}

const BOOKMARKS_BY_ID_UPDATED = (state, bookmarksById) => {
  state.bookmarksById = bookmarksById
}

const USER_BOOKMARKS_COURSES_UPDATED = (state, bookmarksByCourse) => {
  state.bookmarksByCourse = bookmarksByCourse
}

const USER_BOOKMARKS_BY_ID_UPDATED = (state, userBookmarksById) => {
  state.userBookmarksById = userBookmarksById
}

const USER_BOOKMARKS_UPDATED = (state, userCourseBookmarks) => {
  state.userCourseBookmarks = userCourseBookmarks
}

const USER_POSTED_BOOKMARK = (state, userBookmarkPosted) => {
  state.userBookmarkPosted = userBookmarkPosted
}

const USER_ACTIVE_COURSES_UPDATED = (state, userActiveCourses) => {
  state.userActiveCourses = userActiveCourses
}

const USER_ACTIVE_COURSE_ADDED = (state, addActiveCourse) => {
  state.addActiveCourse = addActiveCourse
}

const USER_ACTIVE_COURSE_REMOVED = (state, deleteActiveCourse) => {
  state.deleteActiveCourse = deleteActiveCourse
}

const USER_HISTORY_UPDATED = (state, history) => {
  state.history = history
}

const USER_RECENT_VIDEOS_UPDATED = (state, recentVideos) => {
  state.recentVideos = recentVideos
}

const USER_PENDING_BOOKMARK = (state, pendingBookmark) => {
  state.pendingBookmark = pendingBookmark
}

const BOOKMARK_DELETED = (state, deleteBookmark) => {
  state.deleteBookmark = deleteBookmark
}

const USER_ALL_COURSE_PROGRESS_UPDATED = (state, allProgress) => {
  state.allProgress = allProgress
}

const USER_ACTIVE_COURSE_PROGRESS_UPDATED = (state, progress) => {
  state.progress = progress
}

const USER_WATCHED_VIDEOS_UPDATED = (state, watchedVideos) => {
  state.watchedVideos = watchedVideos
}

const USER_MARKED_VIDEO_AS_WATCHED = (state, markVideoAsWatched) => {
  state.markVideoAsWatched = markVideoAsWatched
}

const USER_UNMARKED_VIDEO_AS_WATCHED = (state, unmarkVideoAsWatched) => {
  state.unmarkVideoAsWatched = unmarkVideoAsWatched
}

const USER_PATH_PROGRESS_UPDATED = (state, pathProgress) => {
  state.pathProgress = pathProgress
}

const USER_PATH_RESUME_UPDATED = (state, pathResume) => {
  state.pathResume = pathResume
}

const USER_ACTIVE_SUBSCRIPTIONS = (state, activeSubscriptions) => {
  state.activeSubscriptions = activeSubscriptions
}

const USER_SAMPLE_AVATARS_UPDATED = (state, sampleAvatars) => {
  state.sampleAvatars = sampleAvatars
}

const USER_AVATAR_UPDATED = (state, avatar) => {
  state.currentAvatar = avatar
}

export default {
  BOOKMARK_DELETED,
  BOOKMARKS_UPDATED,
  BOOKMARKS_BY_ID_UPDATED,
  USER_BOOKMARKS_BY_ID_UPDATED,
  USER_BOOKMARKS_UPDATED,
  USER_POSTED_BOOKMARK,
  USER_ACTIVE_COURSES_UPDATED,
  USER_ACTIVE_COURSE_ADDED,
  USER_ACTIVE_COURSE_REMOVED,
  USER_HISTORY_UPDATED,
  USER_RECENT_VIDEOS_UPDATED,
  USER_BOOKMARKS_COURSES_UPDATED,
  USER_PENDING_BOOKMARK,
  USER_ALL_COURSE_PROGRESS_UPDATED,
  USER_ACTIVE_COURSE_PROGRESS_UPDATED,
  USER_WATCHED_VIDEOS_UPDATED,
  USER_MARKED_VIDEO_AS_WATCHED,
  USER_UNMARKED_VIDEO_AS_WATCHED,
  USER_PATH_PROGRESS_UPDATED,
  USER_PATH_RESUME_UPDATED,
  USER_ACTIVE_SUBSCRIPTIONS,
  USER_SAMPLE_AVATARS_UPDATED,
  USER_AVATAR_UPDATED,
}
